export const formatDateTimeToUTC = (dateString) => {
  const date = new Date(dateString);
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const formattedDate =
    `${String(date.getUTCMonth() + 1).padStart(2, '0')}-` + // Months are zero-based
    `${String(date.getUTCDate()).padStart(2, '0')}-` +
    `${String(date.getUTCFullYear()).slice(-2)}`; // Slice the last two digits for the year

  // Check if both hours and minutes are 00
  if (hours === 0 && minutes === 0) {
    return formattedDate; // Return only the date
  } else {
    return `${formattedDate} ${String(hours).padStart(2, '0')}:${String(
      minutes
    ).padStart(2, '0')}`; // Return time and date
  }
};

export const formatDateToUTC = (dateString) => {
  const date = new Date(dateString);
  const formattedDate =
    `${String(date.getUTCMonth() + 1).padStart(2, '0')}-` + // Months are zero-based
    `${String(date.getUTCDate()).padStart(2, '0')}-` +
    `${String(date.getUTCFullYear()).padStart(2, '0')} `;

  return formattedDate;
};

export const formatAppointmentTime = (dateString, timeStart, timeEnd) => {
  if (!dateString) return '';

  const date = new Date(dateString);
  const formattedDate =
    `${String(date.getUTCDate()).padStart(2, '0')}-` +
    `${String(date.getUTCMonth() + 1).padStart(2, '0')}-` + // Months are zero-based
    `${String(date.getUTCFullYear())}`;

  // Format time range if both start and end times are provided
  if (timeStart && timeEnd) {
    // Remove AM/PM and format to 24-hour format
    const startTime = timeStart.replace(/\s?(AM|PM)/gi, '');
    const endTime = timeEnd.replace(/\s?(AM|PM)/gi, '');
    return `${formattedDate} (${startTime}-${endTime})`;
  }

  // If only start time is provided, use it
  if (timeStart) {
    const startTime = timeStart.replace(/\s?(AM|PM)/gi, '');
    return `${formattedDate} (${startTime})`;
  }

  return formattedDate;
};

export const formatDateLocale = (dateString) => {
  if (!dateString) return '';

  const date = new Date(dateString);
  const formatted = date.toLocaleString(undefined, {
    month: '2-digit',
    day: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

  // Convert from MM/DD/YY, HH:MM to MM-DD-YY HH:MM
  return formatted.replace(/\//g, '-').replace(', ', ' ');
};
